var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyTire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125,0 C19.1605469,0 20,0.839450197 20,1.87499346 L20,13.1249542 C20,14.1604975 19.1605469,14.9999477 18.125,14.9999477 L6.875,14.9999477 C5.83945313,14.9999477 5,14.1604975 5,13.1249542 L5,1.87499346 C5,0.839450197 5.83945313,0 6.875,0 L18.125,0 L18.125,0 Z M6.875,16.2499433 C5.151875,16.2499433 3.75,14.8480732 3.75,13.1249542 L3.75,4.99998256 L1.875,4.99998256 C0.839453125,4.99998256 0,5.83943275 0,6.87497602 L0,18.1249368 C0,19.16048 0.839453125,19.9999302 1.875,19.9999302 L13.125,19.9999302 C14.1605469,19.9999302 15,19.16048 15,18.1249368 L15,16.2499433 L6.875,16.2499433 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyTire);
export default __webpack_public_path__ + "static/media/copy_tire.ae83e7744d3012ed308637d21aa17037.svg";
export { ForwardRef as ReactComponent };